import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactMethods = ({ onMethodSelect }) => {
  const [hoveredMethod, setHoveredMethod] = useState(null);

  const contactMethods = [
    {
      id: 'consultation',
      title: 'Strategic Consultation',
      description: 'Comprehensive 45-minute strategy session to understand your goals and craft a tailored digital roadmap.',
      icon: 'Users',
      color: 'accent',
      features: ['Goal Assessment', 'Strategy Planning', 'Custom Proposal', 'Timeline Discussion'],
      duration: '45 minutes',
      availability: '11 AM - 8 PM IST'
    },
    {
      id: 'quick-audit',
      title: 'Quick Digital Audit',
      description: 'Immediate analysis of your current digital presence with actionable recommendations.',
      icon: 'Search',
      color: 'trust',
      features: ['Website Analysis', 'SEO Review', 'Social Media Check', 'Instant Report'],
      duration: '15 minutes',
      availability: 'Available 24/7'
    },
    {
      id: 'live-chat',
      title: 'Live Chat Support',
      description: 'Connect instantly with our team for quick questions and immediate assistance.',
      icon: 'MessageSquare',
      color: 'success',
      features: ['Instant Response', 'Expert Guidance', 'Project Queries', 'Technical Support'],
      duration: 'Real-time',
      availability: 'Mon-Fri, 11 AM - 8 PM IST'
    },
    {
      id: 'project-brief',
      title: 'Project Brief Wizard',
      description: 'Guided questionnaire to help us understand your project requirements in detail.',
      icon: 'FileText',
      color: 'conversion',
      features: ['Detailed Requirements', 'Budget Planning', 'Timeline Mapping', 'Accurate Quotes'],
      duration: '10-15 minutes',
      availability: 'Self-service'
    }
  ];

  const getColorClasses = (color, isHovered) => {
    const colors = {
      accent: isHovered ? 'bg-accent text-white' : 'bg-accent/10 text-accent border-accent/20',
      trust: isHovered ? 'bg-trust text-white' : 'bg-trust/10 text-trust border-trust/20',
      success: isHovered ? 'bg-success text-white' : 'bg-success/10 text-success border-success/20',
      conversion: isHovered ? 'bg-conversion text-white' : 'bg-conversion/10 text-conversion border-conversion/20'
    };
    return colors?.[color] || colors?.accent;
  };

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Choose Your Preferred Connection Method
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            We believe in meeting you where you're most comfortable. Select the engagement style that works best for your schedule and communication preferences.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {contactMethods?.map((method) => (
            <div
              key={method?.id}
              className={`relative p-8 rounded-2xl border-2 brand-transition cursor-pointer brand-hover-lift ${
                getColorClasses(method?.color, hoveredMethod === method?.id)
              }`}
              onMouseEnter={() => setHoveredMethod(method?.id)}
              onMouseLeave={() => setHoveredMethod(null)}
              onClick={() => onMethodSelect(method?.id)}
            >
              <div className="flex items-start space-x-4">
              

                  <div
  className={`p-3 rounded-xl ${
    hoveredMethod === method?.id ? "bg-white/20" : `bg-${method?.color}/20`
  }`}
>

                  <Icon 
                    name={method?.icon} 
                    size={24} 
                    className={hoveredMethod === method?.id ? 'text-white' : `text-${method?.color}`}
                  />
                </div>
                
                <div className="flex-1">
                  <h3 className="text-xl font-bold mb-2">{method?.title}</h3>
                  <p className={`mb-4 ${
                    hoveredMethod === method?.id ? 'text-white/90' : 'text-muted-foreground'
                  }`}>
                    {method?.description}
                  </p>

                  <div className="space-y-3 mb-6">
                    <div className="grid grid-cols-2 gap-2">
                      {method?.features?.map((feature, index) => (
                        <div key={index} className="flex items-center space-x-2">
                          <Icon 
                            name="Check" 
                            size={16} 
                            className={hoveredMethod === method?.id ? 'text-white' : `text-${method?.color}`}
                          />
                          <span className={`text-sm ${
                            hoveredMethod === method?.id ? 'text-white/90' : 'text-foreground'
                          }`}>
                            {feature}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex justify-between items-center text-sm mb-4">
                    <div className="flex items-center space-x-2">
                      <Icon name="Clock" size={16} />
                      <span>{method?.duration}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="Calendar" size={16} />
                      <span>{method?.availability}</span>
                    </div>
                  </div>

                  <Button
                    variant={hoveredMethod === method?.id ? "outline" : "default"}
                    className={`w-full ${
                      hoveredMethod === method?.id 
                        ? 'border-white/30 text-white hover:bg-white/10' 
                        : `bg-${method?.color} hover:bg-${method?.color}/90 text-white`
                    }`}
                    iconName="ArrowRight"
                    iconPosition="right"
                    iconSize={16}
                  >
                    Get Started
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;